import { render, staticRenderFns } from "./ButtonAsync.vue?vue&type=template&id=0b2debff&"
import script from "./ButtonAsync.vue?vue&type=script&lang=js&"
export * from "./ButtonAsync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports